// extracted by mini-css-extract-plugin
export default {"wrapper":"main-02_wrapper__s5eh3","container":"main-02_container__Wm8NJ"};